import { z } from 'zod/v4';

export const entityStateOptions = [
  'Enabled',
  'Disabled',
  'Suspended',
  'Expired',
] as const;

export const entityStateSchema = z.enum(entityStateOptions);

export type EntityState = z.infer<typeof entityStateSchema>;
